{
  "version": 1,
  "asset_id": "b12080d8-80f6-4616-af1b-64506f0c087f",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/b12080d8-80f6-4616-af1b-64506f0c087f/hiatal-type-1-repair-en-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/b12080d8-80f6-4616-af1b-64506f0c087f/hiatal-type-1-repair-en-480.webp",
  "original_filename": "hiatal-type-1-repair-en-480.webp",
  "size": 19496,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:54:45Z"
}
